// extracted by mini-css-extract-plugin
export default {"banner":"BannerSwiper_banner__Rt876"};